import { useMutation } from '@tanstack/react-query';

import type {
  BomBuilderStructureState,
  MutationFunction,
  QuoteItemBaqData,
} from '@frontend/api';
import { useRequest } from '@frontend/api';

export type UseUpdateQuoteItemRequestVars = {
  quoteItemId: number;
  publicNotes?: string | null;
  privateNotes?: string | null;
  exportControlled?: boolean;
  position?: number;
  workflowStatus?: string | null;
  metadata?: string | null;
  bomDraftState?: BomBuilderStructureState | null;
  bomDraftUpdatedDate?: string | null;
};

export const useUpdateQuoteItem: MutationFunction<
  QuoteItemBaqData,
  UseUpdateQuoteItemRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteItemId, ...body }) =>
      request(`/quotes/items/${quoteItemId}`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }),
    queryOptions,
  );
};
